import styled from 'styled-components/macro';

import HeadingBase from '@components/common/core/DataDisplay/Heading';
import TextBase from '@components/common/core/DataDisplay/Text';
import InputGroupBase from '@components/common/core/Inputs/InputGroup';
import LabelBase from '@components/common/core/DataDisplay/Label';
import TextFieldBase from '@components/common/core/Inputs/TextField';
import FormBase from '@components/common/core/Inputs/Form';
import LinkBase from '@components/common/core/Navigation/Link';
import ImageBase from '@components/common/core/DataDisplay/Image';

export const FunctionalityDescriptionText = styled(TextBase)`
  display: block;
  margin-bottom: 16px;
`;

export const ZoutiLink = styled.a`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.green.default};
  font-weight: 700;
  text-decoration: unset;
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    filter: brightness(1.1);
    text-decoration: underline;
  }

  &:active {
    filter: brightness(0.9);
    text-decoration: underline;
  }
`;

export const TextField = styled(TextFieldBase)`
  width: 100%;
`;

export const Label = styled(LabelBase)``;

export const InputGroup = styled(InputGroupBase)`
  max-width: 408px;
  margin-bottom: 24px;
`;

export const TutorialText = styled(TextBase)`
  line-height: 120%;
  color: ${({ theme }) => theme.colors.gray[1]};
`;

export const Link = styled(LinkBase)`
  display: inline;
`;

export const Benefit = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const BenefitsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
`;

export const DescriptionText = styled(TextBase)`
  line-height: 120%;
`;

export const DescriptionTitle = styled(HeadingBase)`
  margin-bottom: 8px;
`;

export const DescriptionWrapper = styled.div`
  margin-bottom: 16px;
`;

export const Form = styled(FormBase)`
  width: auto;

  @media only screen and (max-width: 920px) {
    margin: 0 auto;
  }
`;

export const IntegrationTitleText = styled(HeadingBase)``;

export const Body = styled.div``;

export const IntegrationTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 28px;
  gap: 16px;
`;

export const Title = styled(HeadingBase)`
  font-size: 1.75rem;
  line-height: 120%;
  margin-bottom: 36px;
`;

export const Header = styled.div``;

export const TutorialStep = styled.li`
  color: ${({ theme }) => theme.colors.font};
  font-size: 0.875rem;
  font-weight: 400;
  font-family: ${({ theme }) => theme.fonts.body};
`;

export const TutorialList = styled.ul`
  margin: unset;
  padding: unset;
  padding-left: 24px;
  margin-bottom: 48px;
`;

export const TutorialTitle = styled(HeadingBase)`
  font-size: 1rem;
  line-height: 120%;
  display: inline-block;
  margin-bottom: 8px;
`;

export const TutorialImage = styled(ImageBase)`
  max-width: 140px;
  margin-bottom: 24px;
  display: block;
`;

export const TutorialWrapper = styled.div`
  max-width: 416px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.gray[4]};
  border-radius: 7px;
  padding: 28px 32px;
  box-sizing: border-box;
  height: fit-content;
`;

export const FormWrapper = styled.div`
  width: 100%;
`;

export const Wrapper = styled.div`
  padding: 142px 32px;
  max-width: calc(1008px + 64px);
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  gap: 28px;

  @media only screen and (max-width: 1292px) {
    flex-direction: column;
    max-width: calc(620px + 64px);
  }
`;

export const WebhookURLWrapper = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background[2]};
  border-radius: 5px;
  height: 42px;
  width: 100%;
  padding: 10px 12px;
  gap: 10px;
  border: unset;
  cursor: pointer;
  /* margin-top: 16px; */
  /* margin-bottom: 24px; */
`;

export const WebhookURL = styled(TextBase)`
  max-width: 434px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const IconWrapper = styled.div`
  min-height: 18px;
  min-width: 18px;
`;
